/* eslint-disable import/prefer-default-export */
export const gwpModalDefaultContentStyles = { padding: '0px' };
